import { ShoppbudAPI, XClientSystem } from '@inhouse-market/sdk';

import { endpoints } from "../env";

import Cookies from 'js-cookie';
import { deviceInfoCache } from './deviceInfoCache';

export * from '@inhouse-market/sdk';

const apiSDK = new ShoppbudAPI({
  async getTokenFn() {
    const authToken = Cookies.get('authorization');
    return authToken!;
  },
  url: endpoints.api,
  "x-device-id": deviceInfoCache() || '',
  "x-platform": "web",
  "x-app-version": process.env.VERSION || '',
  "x-user-id": Cookies.get('userId') || '',
  'x-client-system': XClientSystem.PWA,
});

export default apiSDK;
